














































































































































import { Component, Vue } from 'vue-property-decorator';
import UpdateBankAccountDataViewModel
  from '@/vue-app/view-models/components/user-profile/user-profile-tabs/user-profile-my-documents-tab/update-bank-account/update-bank-account-data-view-model';

@Component({ name: 'UpdateBankAccountData' })
export default class UpdateBankAccountData extends Vue {
  update_bank_account_data_view_model = Vue.observable(
    new UpdateBankAccountDataViewModel(this),
  );

  async mounted() {
    await this.update_bank_account_data_view_model.initialize();
  }
}
